import { Component, Input, OnInit, Optional } from '@angular/core';
import { NbDialogRef, NbCardModule, NbButtonModule } from '@nebular/theme';
import { TranslateModule } from '@ngx-translate/core';


@Component({
    selector: 'app-side-form-dialog',
    templateUrl: './side-form-dialog.component.html',
    styleUrls: ['./side-form-dialog.component.scss'],
    standalone: true,
    imports: [
    NbCardModule,
    NbButtonModule,
    TranslateModule
  ],
})
export class SideFormDialogComponent implements OnInit {

  @Input() public canCancel: boolean = true;
  @Input() public wider: boolean = false;

  public title: string = '';
  public content: string = '';

  constructor(
    @Optional() public ref: NbDialogRef<SideFormDialogComponent>
  ) { }

  public ngOnInit(): void { }

  public close(confirmation: boolean = false): void {
    if (this.ref) {
      this.ref.close(confirmation);
    }
  }
}
